import { FooterButtonGroup, FooterButton } from "./footer";

const voteIcon = (color: string) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.23529 8.88306V17.6637C5.23529 17.9548 5.12374 18.234 4.92517 18.4399C4.7266 18.6457 4.45729 18.7613 4.17647 18.7613H2.05882C1.77801 18.7613 1.50869 18.6457 1.31012 18.4399C1.11155 18.234 1 17.9548 1 17.6637V9.98064C1 9.68954 1.11155 9.41037 1.31012 9.20453C1.50869 8.99869 1.77801 8.88306 2.05882 8.88306H5.23529ZM5.23529 8.88306C6.35856 8.88306 7.43583 8.4205 8.2301 7.59715C9.02437 6.7738 9.47059 5.6571 9.47059 4.49271V3.39512C9.47059 2.81293 9.6937 2.25458 10.0908 1.8429C10.488 1.43123 11.0266 1.19995 11.5882 1.19995C12.1499 1.19995 12.6885 1.43123 13.0856 1.8429C13.4828 2.25458 13.7059 2.81293 13.7059 3.39512V8.88306H16.8824C17.444 8.88306 17.9826 9.11433 18.3798 9.52601C18.7769 9.93768 19 10.496 19 11.0782L17.9412 16.5662C17.7889 17.2395 17.5 17.8177 17.1181 18.2136C16.7362 18.6095 16.2818 18.8018 15.8235 18.7613H8.41177C7.56931 18.7613 6.76137 18.4144 6.16566 17.7969C5.56996 17.1794 5.23529 16.3419 5.23529 15.4686"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function VotingButton({
  highlight,
  onClick,
  disabled,
}: {
  highlight: boolean;
  onClick: () => void;
  disabled: boolean;
}) {
  return (
    <FooterButtonGroup>
      <FooterButton testid="voting" tooltip="Voting" onClick={onClick} disabled={disabled}>
        {voteIcon(highlight ? "var(--blue)" : "var(--dark")}
      </FooterButton>
    </FooterButtonGroup>
  );
}
